import { render, staticRenderFns } from "./radio-transfer-list-item.vue?vue&type=template&id=b886807a"
import script from "./radio-transfer-list-item.vue?vue&type=script&lang=js"
export * from "./radio-transfer-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports